import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const searchBarApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSearch: builder.query({
      query: (text) => `/search_bar?search=${text}`,
      providesTags: (result, error, arg) => [{ type: 'Search', id: arg }],
    })
  }),
  overrideExisting: false
})

export const {
  useLazyGetSearchQuery
} = searchBarApiSlice
